(() => {
  if (!/^\/products\/1056745702293\/?$/.test(location.pathname)) return;
  const blockId = '26960cb5-9491-44fa-ab83-44a2515d3a83';
  let pending = false;
  let tier = '1';
  const update = () => {
    pending = false;
    const block = document.querySelector(`kaching-bundles-block[deal-block-id="${blockId}"]`);
    if (!block) return;
    const bars = [...block.querySelectorAll('.kaching-bundles__bar')];
    const info = bars.map(bar => {
      const node = bar.querySelector('.kaching-bundles__bar-title');
      const title = bar.dataset.wehOfferTitle || node?.textContent.trim() || '';
      if (/^(Single|Set)\s*—/.test(title)) {
        bar.dataset.wehOfferTitle = title;
        const visibleTitle = title.replace(/^[^—]+—\s*/, '');
        if (node && node.textContent.trim() !== visibleTitle) node.textContent = visibleTitle;
      }
      return {bar, title};
    });
    if (info.filter(x => /^(Single|Set)\s*—/.test(x.title)).length !== 6) return;
    const size = document.querySelector('input[data-option-name="Color classification"]:checked')?.value;
    const capacity = size?.includes('(set)') ? 'Set' : size?.includes('(single)') ? 'Single' : ''; 
    if (!['Single', 'Set'].includes(capacity)) return;
    const visible = [];
    for (const {bar, title} of info) {
      const match = title.startsWith(capacity + ' —');
      const display = match ? '' : 'none';
      if (bar.style.display !== display) bar.style.display = display;
      if (bar.getAttribute('aria-hidden') !== String(!match)) bar.setAttribute('aria-hidden', String(!match));
      if (!match) continue;
      visible.push(bar);
      const variants = bar.querySelector('.kaching-bundles__bar-variants');
      if (variants && variants.style.display !== 'none') variants.style.display = 'none';
      const products = bar.querySelector('.kaching-bundles__bundle-products');
      if (products && products.style.display !== 'none') products.style.display = 'none';
      for (const select of bar.querySelectorAll('select[data-name="Color classification"]')) {
        if (select.value !== size) {
          select.value = size;
          select.dispatchEvent(new Event('change', {bubbles: true}));
        }
      }
    }
    if (!visible.some(bar => bar.classList.contains('kaching-bundles__bar--selected'))) {
      const preferred = visible.find(bar => bar.querySelector('.kaching-bundles__bar-title')?.textContent.includes('Buy ' + tier)) || visible[0];
      preferred?.querySelector('label.kaching-bundles__bar-container')?.click();
    }
  };
  const schedule = () => {
    if (!pending) { pending = true; requestAnimationFrame(update); }
  };
  document.addEventListener('change', schedule);
  document.addEventListener('click', event => {
    const title = event.target.closest('.kaching-bundles__bar')?.querySelector('.kaching-bundles__bar-title')?.textContent;
    const match = title?.match(/Buy (\d)/);
    if (match) tier = match[1];
    schedule();
  });
  new MutationObserver(schedule).observe(document.documentElement, {childList: true, subtree: true});
  schedule();
})();
